import React from 'react';
export function Footer() {
  return <footer className="bg-charcoal text-warmgray py-8 text-center text-sm" data-id="element-28">
      <div className="max-w-6xl mx-auto px-6" data-id="element-29">
        <p data-id="element-30">
          © {new Date().getFullYear()} Hogar en Autopiloto. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}